export function toggleVersion() {
  const scope = this.getCanvasScope()
  const { isVersionsOpen } = this.getRootState()
  const Versions = this.lookup('Versions')
  const Playground = this.lookup('Playground')

  if (isVersionsOpen) {
    // if (data.explorer) {
    //   scope.explorer = false
    //   this.data.sidebarCached = true
    //   // this.EditorPanels.CanvasProjectSidebar.update()
    // }

    // LOOKUP-SHAPE-1: `Versions`/`Playground` are captured once above (a
    // `lookup()` miss returns undefined) and then derefed unguarded inside
    // nested `window.setTimeout`s below — a miss there threw into nothing
    // (no error surface, user-invisible) instead of throwing loudly where
    // this ran inline. Guarded every deref; a miss now no-ops instead of
    // throwing into a timer.
    const closeVersions = () => {
      Playground?.setNodeStyles(Playground?.['.isVersionsOpen'])
      const { selected, chosen } = scope
      scope.selectedCached = selected
      scope.chosenCached = chosen

      const t2 = window.setTimeout(() => {
        this.activateSelected(null)
        this.activateChosen(null)

        const t3 = window.setTimeout(() => {
          Versions?.VersionsAside?.setNodeStyles(Versions?.VersionsAside?.fadeIn)
          Versions?.VersionFooter?.setNodeStyles(Versions?.VersionFooter?.fadeIn)
          clearTimeout(t3)
        }, 35)
        clearTimeout(t2)
      }, 35)
    }
    const t = window.setTimeout(() => {
      if (Playground) {
        closeVersions()
      } else {
        const t2 = window.setTimeout(() => {
          closeVersions()
          clearTimeout(t2)
        }, 350)
      }
      clearTimeout(t)
    }, 350)
  } else {
    Playground?.setNodeStyles(Playground?.['!isVersionsOpen'])
    Versions?.VersionsAside?.setNodeStyles(Versions?.VersionsAside?.fadeOut)
    Versions?.VersionFooter?.setNodeStyles(Versions?.VersionFooter?.fadeOut)

    const t = window.setTimeout(() => {
      const t2 = window.setTimeout(() => {
        // if (scope.sidebarCached) {
        //   delete scope.sidebarCached
        //   // this.EditorPanels.update()
        // }
        const t3 = window.setTimeout(() => {
          const { selectedCached, chosenCached } = scope
          if (selectedCached) {
            this.activateSelected(selectedCached)
          }
          if (chosenCached) {
            this.activateChosen(chosenCached)
          }
          clearTimeout(t3)
        }, 35)
        clearTimeout(t2)
      }, 35)
      clearTimeout(t)
    }, 35)
  }
}
